import { useEffect, useState } from "react";
import { api } from "../../services/api";

export type ZodiacReading = {
  date: string;
  theme: string;
  message: string;
  // Absent on cards saved before spec v1.1.
  energyLevel?: string;
  dailyEncouragement?: string;
  luckyWindow: string;
  luckyColor: string;
  luckyColorHex?: string;
  smallLuck: string;
  lifeGPSSignal: string;
};

/** Today's reading from GET /backend/zodiac/today (null while loading or on failure). */
export const useZodiacToday = (lang: string): ZodiacReading | null => {
  const [reading, setReading] = useState<ZodiacReading | null>(null);

  useEffect(() => {
    let active = true;
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    api
      .get("/backend/zodiac/today", { params: tz ? { tz } : {} })
      .then((r) => active && setReading(r.data?.data ?? null))
      .catch(() => {
        // The page still renders from the headline data when this fails.
      });
    return () => {
      active = false;
    };
  }, [lang]);

  return reading;
};
